<template>
 <div>
   <div class="random-rewards-bind_wrapper">
      <div class="random-rewards-bind_text">
        <h1 class="heading1" v-html="$c('Привяжи карту с помощью уникального %(br)s 12-значного бонусного номера', {br : '<br/>'})" />
        <p class="random-rewards-bind_attention">
          <span class="red-text-20">{{ $c('Обрати внимание!') }}</span>
          {{ $c('После завершения операции ты не сможешь привязать другую карту.') }}
        </p>
      </div>
    </div>
    <form :class="['random-rewards-bind_form', {'random-rewards-bind_form__error': error === PARTICIPATE_ERROR}]">
      <TheMask
        class="random-rewards-bind_input"
        type="text"
        ref="input"
        v-model="inputValue"
        mask="FFFF - FFFF - FFFF"
        placeholder="XXXX - XXXX - XXXX"
        v-autowidth="{maxWidth: '960px', minWidth: '162px', comfortZone: 0}"
        :tokens="maskTokens"
      />
      <div class="random-rewards-bind_info">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.54 17.5H11.46V9.5752H13.54V17.5ZM11.3647 7.52441C11.3647 7.20215 11.4673 6.93848 11.6724 6.7334C11.8774 6.52832 12.1509 6.42578 12.4927 6.42578C12.8345 6.42578 13.1079 6.52832 13.313 6.7334C13.5181 6.93848 13.6206 7.20215 13.6206 7.52441C13.6206 7.8418 13.5181 8.10547 13.313 8.31543C13.1128 8.52539 12.8394 8.63037 12.4927 8.63037C12.146 8.63037 11.8701 8.52539 11.665 8.31543C11.4648 8.10547 11.3647 7.8418 11.3647 7.52441Z" fill="#666666"/>
          <rect x="0.5" y="0.5" width="24" height="24" rx="12" stroke="#666666"/>
        </svg>
        <div class="random-rewards-bind_info-hint">
          <span>{{ $c('Уникальный 12-значный бонусный номер ищи на оборотной стороне карты.') }}</span>
          <img src="/img/random-rewards/where-is-code.png" alt="">
        </div>
      </div>
      <div
        class="random-rewards-bind_error"
        v-if="error === PARTICIPATE_ERROR"
      >
        {{ $c(errorDetails, {cardCode: participateCardCode, game: GAME_NAMES[randomButtonData.game]}) }}
      </div>
    </form>
    <div class="random-rewards-bind_wrapper random-rewards-bind_buttons">
      <a
        href="#"
        :class="['button', 'contained', {disabled : this.inputValue.length !== 12}]"
        @click.prevent="onParticipate"
      >{{ $c('Привязать карту') }}</a>
      <a @click="$root.$emit('closeRandomRewardsPopUp')" class="button outlined ml20">{{ $c('Отмена') }}</a>
    </div>
 </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { TheMask } from 'vue-the-mask'
import { namespace, State } from 'vuex-class'
import { PARTICIPATE_ERROR } from '@/store/modules/random-rewards'
import { GAME_NAMES } from '@/constants'
const randomRewards = namespace('randomRewards')

@Component({
  components: {
    TheMask
  }
})
class BindCardForm extends Vue {
  @randomRewards.Action('participate') participate
  @randomRewards.State('error') error
  @randomRewards.State('errorDetails') errorDetails
  @randomRewards.State('participateCardCode') participateCardCode
  @State('randomButtonData') randomButtonData
  PARTICIPATE_ERROR = PARTICIPATE_ERROR
  maskTokens = { F: { pattern: /[0-9a-zA-Z]/, transform: v => v.toUpperCase() } }
  inputValue = ''
  GAME_NAMES = GAME_NAMES

  onParticipate () {
    if (this.inputValue.length !== 12) return true
    this.participate(this.inputValue)
  }
}

export default BindCardForm
</script>
